// extracted by mini-css-extract-plugin
export var searchHeader = "_2l-0";
export var searchHeaderDark = "_2l-1";